<template>
  <div class="index">
    <!-- banner开始 -->
    <div class="indexv-all">
      <img
        class="indeximg"
        src="https://donetwork.clearlovex.com/donetweb/donetwork_bg1.png"
      />
      <!-- <video
        width="100%"
        height="100%"
        autoplay="autoplay"
        muted="true"
        class="indexvideo"
        loop="loop"
      >
        <source src="../../assets/pc/intro/water.mp4" type="video/mp4" />
      </video> -->

      <div class="index_background">
        <div class="banner">
          <div class="title">
            <div class="title1">{{ $t("home.title[0]") }}</div>
            <div class="title1">{{ $t("home.title[1]") }}</div>
            <div class="title1">{{ $t("home.title[2]") }}</div>
          </div>
          <div class="subTitle-all">
            <div class="subTitle">
              <p class="title1">{{ $t("home.Unbelievable") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- banner结束 -->
    <div class="Do_Dao">
      <Do ref="Do"></Do>
      <Dao ref="Dao"></Dao>
    </div>

    <Technical ref="technical"></Technical>
    <!-- 图开始 -->

    <div class="img"></div>
    <!-- 图结束 -->
    <div class="runDao2">
      <div class="start">{{ $t("DAO.start") }}</div>
    </div>
    <div class="runDao">
      <div class="link-top top"></div>
      <div class="center">
        <div class="cmd code-wrapper" v-html="codeContent"></div>
        <a target="_blank" href="https://www.donetwork.io/doc/"
          ><button class="button">{{ $t("DAO.build") }}</button></a
        >
      </div>
      <div class="link-top bottom"></div>
    </div>
    <!-- 合作伙伴 -->
     <!-- <div class="partner">
       <div class="partner_w">
        <div class="partner_wh">
          <div class="line"></div>
          <div class="title">Core Partners</div>
          <div class="line"></div>
        </div>
       </div>
     </div> -->
     <!-- 合作伙伴结束 -->
    <!-- 团队成员 -->
    <!-- <div class="team-member">
      <div class="title-container">
        <div class="title-main">{{ $t("TeamMember.Global") }}</div>
        <div class="title-main">
          {{ $t("TeamMember.distributed") }}
          <span> {{ $t("TeamMember.members") }} </span>
        </div>
      </div>
      <TeamMember></TeamMember>
    </div> -->

    <Partners ref="partners"></Partners>
    <!-- 联系我们开始 -->
    <!-- <div class="runemail">
      <div class="emailcontent">
        <div class="title">Contact Us</div>
        <div><img src="../../assets/pc/email.png" /></div>
        <div class="submit">Submit Feedback</div>
        <div class="email">donetwork@outlook.com</div>
        <div class="content">
          Having trouble using the product?<br />Try asking the support team
          for<br />
          answers
        </div>
      </div>
    </div> -->
    <!-- 联系我们结束 -->
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import "swiper/swiper.less";
// import { WOW } from "wowjs";
import Do from "@/views/pc/Do.vue";
import Dao from "@/views/pc/Dao.vue";
import Technical from "@/views/pc/Technical.vue";
import Partners from "@/views/pc/Partners.vue";
import TeamMember from "@/views/pc/TeamMember.vue";

// import {
//   Do,
//   Dao,
//   Technical,
//   Partners,
// } from "@/assets/server/api.js";
// import { baseURL, trimHtml } from "@/utils/utils";
// import { setInterval } from "timers";
export default {
  components: {
    Do,
    Dao,
    Technical,
    Partners,
    TeamMember,
  },
  computed: {},
  data() {
    return {
      codeContent: `
          <p><span class="code-purple">uint64_t i</span> = <span class="code-brown">1</span><span class="code-gray">;</span></p>
          <p><span class="code-purple">auto</span> fn = <span class="code-gray">[&]() {</span></p>
              <p>\u00a0\u00a0\u00a0\u00a0<span class="code-blue">const</span> <span class="code-purple">auto</span> <span class="code-gray">&</span>res = <span class="code-purple">_runtime</span><span class="code-gray">-></span><span class="code-purple">_bkend</span><span class="code-gray">-></span><span class="code-brown bold">call_with_return</span><span class="code-gray">(</span></p>
                      <p>\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0pContext, "<span class="code-green">env</span>", "<span class="code-green">apply</span>", i, i, <span class="code-purple bold">wasm</span><span class="code-gray">::</span><span class="code-brown bold">name</span><span class="code-gray">(</span><span class="code-purple">pContext</span><span class="code-gray">-></span><span class="code-brown bold">action</span><span class="code-gray">()).</span><span class="code-purple">value</span><span class="code-gray">);</span></p>
              <p>\u00a0\u00a0\u00a0\u00a0apply_return = <span class="code-brown bold">wasm_to_int64</span><span class="code-gray">(</span>res<span class="code-gray">);</span></p>
          <p><span class="code-gray">};</span></p>
          <p><span class="code-purple bold">watchdog</span> <span class="code-brown bold">wd</span><span class="code-gray">(</span><span class="code-purple bold">pContext</span><span class="code-gray">-></span><span class="code-brown bold">get_max_transaction_duration</span><span class="code-gray">());</span></p>
          <p><span class="code-purple">_runtime</span><span class="code-gray">-></span><span class="code-purple">_bkend</span><span class="code-gray">-></span><span class="code-brown bold">timed_run</span><span class="code-gray">(</span>wd, fn<span class="code-gray">);</span></p>
        `,
    };
  },
  created() {},
  mounted() {
    // document.getElementById('app-cockpit-loading').remove();
    //  this.suofang()
  },
  destroyed() {},
  methods: {
    // suofang(){
    //   // 以.app-main 为例
    //   if (window.devicePixelRatio == 1.5) {
    //     document.getElementsByClassName("indeximg")[0].style.background = "red"
    //   }
    //   if (window.devicePixelRatio == 1.25) {
    //       document.getElementsByClassName("indeximg")[0].style.top = "256px"
    //   }
    // }
  },
};
</script>
<style lang="less">
.code-wrapper {
  .code-purple {
    color: #7a3e9d;
  }
  .code-black {
    color: #6b3333;
  }
  .code-blue {
    color: #4b69c6;
  }
  .code-gray {
    color: #777;
  }
  .code-green {
    color: #448c27;
  }
  .code-brown {
    color: #9c5d63;
  }
  .bold {
    font-weight: bold;
  }
}
.w1352 {
  width: 1200px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
@keyframes showBottom {
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes hideBottom {
  to {
    opacity: 0;
    transform: translateY(100px);
  }
}
</style>
<style lang="less" scoped>
@keyframes showLeft {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes showRight {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes hideLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@keyframes hideRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes scaleUp-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scaleDown-animation {
  0% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
@media screen and (min-width: 1024px) {
  .index_background {
    background-position: 0 12% !important;
  }
}
@media screen and (min-width: 1100px) {
  .index_background {
    background-position: 0 12% !important;
  }
}
@media screen and (min-width: 1280px) {
  .index_background {
    background-position: 0 12% !important;
  }
}
@media screen and (min-width: 1366px) {
  .index_background {
    background-position: 0 12% !important;
  }
}
@media screen and (min-width: 1440px) {
  .index_background {
    background-position: 0 12% !important;
  }
}
@media screen and (min-width: 1680px) {
  .index_background {
    background-position: 0 12% !important;
  }
}
@media screen and (min-width: 1920px) {
  .index_background {
    // background-position: 0 -84px !important;
  }
  .banner {
    height: 1785px;
  }
  // .indeximg {
  //   height: 1785px;
  //   transform: scale(1.5, 1.5);
  // }
}
@media screen and (min-width: 2048px) {
  .index_background {
    background-position: 0 -84px !important;
  }
  // .indeximg {
  //   zoom: 150%;
  //   height: 1000px;
  // }

  // @-ms-viewport {
  //   width: 2048px;
  // }
}
@media screen and (min-width: 2560px) {
  .index_background {
    background-position: 0 -84px !important;
  }
  //  .indeximg {
  //   height: 2785px;
  // }
}
@media screen and (min-width: 3024px) {
  .index_background {
    background-position: 0 12% !important;
  }
}
@media screen and (min-width: 4096px) {
  .index_background {
    background-position: 0 12% !important;
  }
}

.scale {
}
// .indeximg{max-height:300px;_height:expression(this.height > 300 ? "300px" : this.height);}
.scale :hover {
  transform: rotate(7deg);
  -ms-transform: rotate(7deg); /* IE 9 */
  -moz-transform: rotate(7deg); /* Firefox */
  -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
  -o-transform: rotate(7deg); /* Opera */
  color: red;
}
.index {
  width: 100%;
  height: 100%;
  font-size: 16px;
  padding-top: 80px;
  position: relative;
  padding-bottom: 271px;
  // border: 1px solid yellow;
  .indexv-all {
    width: 100%;
    height: 100%;
    overflow: hidden;
    // border: 1px solid red;
    // position: fixed;
    .indexvideo {
      position: relative;
      overflow: hidden;
      //height: 100%;
      //opacity: 0.8;
      zoom: 1;
      height: 1385px;
      object-fit: fill;
    }
    .indeximg {
      position: absolute;
      top: -100px;
      width: 100%;
      // height: 1900px;
      // _height:1900px;
      //  min-height: 1760px;
      // height: 1760px;
      z-index: 99;
      // zoom: 100%;
      //transform: scale(1);
      transform: scale(1);
    }
    .index_background {
      margin-top: 80px;
      position: absolute;
      left: 50%;
      top: 0;
      width: 100%;
      overflow: hidden;
      transform: translate(-50%, 0%);
      //  background: url("https://donetwork.clearlovex.com/donetweb/donetwork_bg1.png")
      //  no-repeat;
      // height: 100%;
      height: 1385px;
      background-attachment: fixed;
      background-size: cover;
      -webkit-background-size: cover; /* 兼容Webkit内核浏览器如Chrome和Safari */
      -o-background-size: cover; /* 兼容Opera */
      zoom: 1;
      //background-size: contain, cover;
      // background: linear-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0.8),rgb(255, 255, 255,1));
      // background-position:0 12%;
      // background-size: 100%;
      // background-clip: content-box;
      // background-size:cover;
      z-index: 999;
      // opacity: 0.5;
      // background-attachment: fixed;
    }
  }
}
.banner {
  width: 1200px;
  // position: absolute;
  // left: 50%;
  // top: 0%;
  // width: 100%;
  overflow: hidden;
  // transform: translate(-50%, 0%);
  // height: 1985px;
  height: 1385px;
  //border: 1p solid red;
  // border: 1px solid red;
  // background: #ffffff;
  text-align: left;
  display: block;
  position: relative;
  color: #1d3244;
  margin: 0 auto;
  .title {
    margin-top: 139px;
    display: block;
    width: 100%;
    margin-left: 20px;
    // height: 291px;
    font-size: 75px;
    font-weight: 900;
    color: #000000;
    line-height: 97px;
    -webkit-background-clip: text;
  }
  .subTitle-all {
    margin-top: 35px;
    .subTitle {
      // width: 60%;
      margin-left: 20px;
      font-size: 45px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #000000;
      line-height: 53px;
      -webkit-background-clip: text;
      .title1 {
        margin-right: 20px;
      }
    }
    .sanTitle {
      // width: 60%;
      margin-left: 20px;
      margin-top: 25px;
      height: 60px;
      font-size: 18px;
      font-weight: 500;
      color: #61666b;
      line-height: 30px;
      -webkit-background-clip: text;
      .title2 {
        display: inline-block;
        text-align: left;
      }
    }
  }
}
.Do_Dao {
  // margin-top: 780px;
  margin-top: 1470px;
  background: -moz-linear-gradient(top, #f2f5f9 0%, #ffffff 100%);
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, #f2f5f9),
    color-stop(100%, #ffffff)
  );
  background: -webkit-linear-gradient(top, #f2f5f9 0%, #ffffff 100%);
  background: -o-linear-gradient(top, #f2f5f9 0%, #ffffff 100%);
  background: -ms-linear-gradient(top, #f2f5f9 0%, #ffffff 100%);
  background: linear-gradient(to bottom, #f2f5f9 0%, #ffffff 100%);
}
.runDao {
  padding-top: 72px;
  text-align: center;
  width: 100%;
  height: 500px;
  padding-bottom: 128px;
  .link-top {
    width: 1190px;
    height: 2px;
    margin: 0 auto;
    text-align: center;
    // background: #cccdd1;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
  .top {
    margin-top: 80px;
  }
  .center {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1200px;
    height: 320px;
    line-height: 320px;
    margin: 0 auto;
    border-bottom: 2px solid #cccdd1;
    border-top: 2px solid #cccdd1;
    .cmd {
      text-align: left;
      font-size: 14px;
      font-family: Poppins-Regular, Poppins;
      font-weight: 400;
      color: #000000;
      line-height: 28px;
      margin-left: 20px;
      letter-spacing: 2px;
      -webkit-background-clip: text;
    }
    .button {
      width: 365px;
      height: 75px;
      background: #111111;
      border-radius: 15px 15px 15px 15px;
      opacity: 1;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      line-height: 21px;
      border: none;
      cursor: pointer;
    }
  }
}
.partner{

}
.team-member {
  margin-top: 230px;
  .title-container {
    margin-bottom: -220px;
    height: 165px;
    text-align: center;
    .title-main {
      font-size: 64px;
      font-family: Poppins-Black, Poppins;
      font-weight: 900;
      color: #000000;
      line-height: 83px;
      // span{
      //     color: #4573E7;
      // }
    }
  }
}
.runDao1 {
  margin-top: 40px;

  .start1 {
    margin: 0 auto;
    width: 1200px;
    font-size: 60px;
    font-weight: 900;
    color: #000000;
    line-height: 77px;
    padding-bottom: 40px;
    overflow: hidden;
    font-family: Poppins-Black, Poppins;
    -webkit-background-clip: text;
    margin-bottom: 5px;
  }
  .detail {
    width: 617px;
    font-size: 20px;
    text-align: center;
    margin: 0 auto;
    font-weight: 600;
    color: #000000;
    line-height: 45px;
  }
  .img {
    height: 250px;

    background-image: url("../../assets/pc/imagesa.png");

    background-repeat: repeat-x;
    // width: 1920px;
    // margin: 0 auto;
    // position: absolute;
    // left: 50%;
    // // margin: 0 auto;
    // overflow: hidden;
    //  img{
    //    width:100%;
    //    margin: 0 auto;
    //    min-width: 1200px;
    //   //  margin: 0 auto;
    //   height: 616px;

    //   background-size: cover;

    // }
  }
}
.runDao2 {
  width: 1200px;
  margin: 0 auto;
  .start {
    width: 785px;
    font-size: 60px;
    font-family: Poppins-Black, Poppins;
    font-weight: 900;
    color: #000000;
    line-height: 77px;
    -webkit-background-clip: text;
    margin-bottom: 5px;
  }
}
.runemail {
  // border: 1px solid red;
  margin-top: 30px;
  text-align: center;
  width: 100%;
  height: 200px;
  .emailcontent {
    width: 1190px;
    margin: 0 auto;
    font-family: Poppins-Black, Poppins;
    
    color: #000000;
    .title {
      font-size: 50px;
      color: #000000;
      line-height: 77px;
    }
     img{
      width:60px;
      height:70px;
      margin-top: 30px;
      margin-bottom: 20px;
    }
    .submit {
      font-size: 30px;
      line-height: 50px;
    }
    .email {
      font-size: 22px;    
      line-height: 50px;
    }
    .content{
      color: #999 !important;
      font-size: 18px;
    }
  }
}
/* 屏幕分辨率放大为 125 */
@media (-webkit-min-device-pixel-ratio: 1) {
  .indeximg {
    top: -34px !important;
    position: absolute;
  }
}

/* 屏幕分辨率放大为 125 */
@media (-webkit-min-device-pixel-ratio: 1.25) {
  .indeximg {
    top: 230px !important;
    position: absolute;
  }
}
/* 屏幕分辨率放大为 150 */
@media (-webkit-min-device-pixel-ratio: 1.5) {
  .indeximg {
    top: 440px !important;
    position: absolute;
  }
}
</style>
